import { useState } from 'react';
import { trackFeedbackOpen } from '../ga';
import { FeedbackModal } from './FeedbackModal';
import './FeedbackFab.css';

/**
 * @param {{
 *   betaNoticeVisible?: boolean;
 *   interactionLocked?: boolean;
 * }} props
 */
export function FeedbackFab({
  betaNoticeVisible = false,
  interactionLocked = false,
}) {
  const [open, setOpen] = useState(false);

  function handleOpen() {
    if (interactionLocked) {
      return;
    }
    trackFeedbackOpen();
    setOpen(true);
  }

  return (
    <>
      <button
        type="button"
        className={[
          'feedback-fab',
          betaNoticeVisible && 'feedback-fab--above-beta',
          interactionLocked && 'feedback-fab--locked',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={handleOpen}
        disabled={interactionLocked}
        aria-haspopup="dialog"
        aria-expanded={open}
        tabIndex={interactionLocked ? -1 : undefined}
      >
        <svg
          className="feedback-fab__icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
        <span className="feedback-fab__label">Feedback</span>
      </button>
      {open && <FeedbackModal onClose={() => setOpen(false)} />}
    </>
  );
}
